import { Set } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import * as perspectives from '../../../../constants/perspectives';
import LargeHero from './LargeHero';
import SmallHero from './SmallHero';

export default class Hero extends Component {
  static propTypes = {
    discoverHeading: PropTypes.string.isRequired,
    query: PropTypes.string,
    perspective: perspectives.propType.isRequired,
    onChangeQuery: PropTypes.func.isRequired,
  };

  render() {
    return (
      <ScreenClassRender render={this.renderHero}>
        <span />
      </ScreenClassRender>
    );
  }

  renderHero = (sc) => {
    // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
    const { discoverHeading, perspective, query, onChangeQuery, onClick } = this.props;
    return Set(['xl', 'lg']).contains(sc) ? (
      <LargeHero
        discoverHeading={discoverHeading}
        perspective={perspective}
        query={query}
        onChangeQuery={onChangeQuery}
        onClick={onClick}
      />
    ) : perspective === perspectives.DISCOVER ? (
      // @ts-expect-error [MC-2850] - TS2769 - No overload matches this call. | TS2304 - Cannot find name 'sc'.
      <SmallHero discoverHeading={discoverHeading} screenClass={sc} />
    ) : null;
  };
}
